<template>
  <mdb-footer color="primary" class="font-small pt-4 mt-4">
    <mdb-container class="text-center">
      <mdb-row>
        <mdb-col col="12" class="py-4">
          <h2 class="h2 pb-4">CONTACT</h2>
          <p class="pb-4">{{ $t('common.contactTo') }}</p>
          <router-link :to="{ name: 'contact' }" class="btn btn-primary btn-rounded mb-4">
            <mdb-icon icon="envelope" class="mr-2"/>
            {{ $t('common.contactForm') }}
          </router-link>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <div class="footer-copyright text-center">
      <mdb-container fluid>
        <mdb-row>
          <mdb-col col="12" md="6" class="py-3 d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-start">
            <a href="https://www.iwatsu.co.jp/" target="_blank" class="py-2">{{ $t('common.operatingCompanyInformation') }}</a>
            <span class="mx-2 d-none d-md-inline">|</span>
            <router-link :to="{ name: 'userPolicy' }" class="py-2">{{ $t('common.userPolicy') }}</router-link>
            <span class="mx-2 d-none d-md-inline">|</span>
            <router-link :to="{ name: 'privacyPolicy' }" class="py-2">{{ $t('common.privacyPolicy') }}</router-link>
            <span class="mx-2 d-none d-md-inline">|</span>
            <router-link :to="{ name: 'paidVersionPrivacyPolicy' }" class="py-2">{{ $t('common.paidVersionPrivacyPolicy') }}</router-link>
            <span class="mx-2 d-none d-md-inline">|</span>
            <router-link :to="{ name: 'help' }" class="py-2">{{ $t('common.help') }}</router-link>
          </mdb-col>
          <mdb-col col="12" md="6" class="py-3 d-flex flex-column align-items-center align-items-md-end justify-content-center">
            <div>
              Copyright &copy; 2020 IWATSU ELECTRIC CO., LTD. All Rights Reserved.
            </div>
            <div class="pt-2">
              <img src="@/assets/images/iwatsu_trade_name_logo.png" height="18"/>
            </div>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </div>
  </mdb-footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="scss">
.footer-copyright img {
  opacity: 0.6;
}
</style>
